import { createApi } from '@reduxjs/toolkit/query/react'
import { deleteWorkspaceById } from '~workspace/api/deleteWorkspaceById'
import { updateWorkspaceById } from '~workspace/api/updateWorkspace'

const amplifyGraphqlBaseQuery = async (data) => {
  return await data
}

const workspaceApi = createApi({
  reducerPath: 'workspaceApi',
  baseQuery: amplifyGraphqlBaseQuery,
  endpoints: (builder) => ({
    updateWorkspaceById: builder.mutation({
      query: async (body) => {
        const { id, ...input } = body
        try {
          const data = await updateWorkspaceById(id, input)
          return { data }
        } catch (error) {
          return { error }
        }
      }
    }),

    deleteWorkspaceById: builder.mutation({
      query: async (id) => {
        try {
          const data = await deleteWorkspaceById(id)
          return { data }
        } catch (error) {
          return { error }
        }
      }
    })
  })
})

export const {
  useUpdateWorkspaceByIdMutation,
  useDeleteWorkspaceByIdMutation
} = workspaceApi
export default workspaceApi
